import { defineStore } from 'pinia'
import { ref } from 'vue'
import { refundsApi } from '@/api'

/**
 * How many refunds are waiting for a decision, for the badge in the sidebar.
 * Polled rather than pushed: a manager needs to notice one arriving without
 * reloading, and the number is cheap to fetch.
 */
export const useRefundQueueStore = defineStore('refundQueue', () => {
  const pending = ref(0)
  let timer: number | null = null

  async function refresh(): Promise<void> {
    try {
      pending.value = (await refundsApi.pendingCount()).pending
    } catch {
      // A failure here must never interrupt what the user is doing.
      pending.value = 0
    }
  }

  function startPolling(intervalMs = 60_000): void {
    if (timer !== null) return
    void refresh()
    timer = window.setInterval(() => void refresh(), intervalMs)
  }

  function stopPolling(): void {
    if (timer !== null) {
      window.clearInterval(timer)
      timer = null
    }
  }

  return { pending, refresh, startPolling, stopPolling }
})
